import React, { memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from './Chat.module.css';

const Chat = memo(function Chat() {
  const router = useRouter();

  const [chatCounter, setChatCounter] = useState(0);

  // useEffect(() => {
  //   // add api req
  //   setChatCounter(77);
  // }, [router]);

  return (
    <a className={styles.chat} target="_blank" href="https://uchi.ru/chat" rel="noopener">
      {chatCounter > 0 && <div className={styles.counter}>{chatCounter}</div>}
      <img src="https://static.uchi.ru/files/otvety/headerV2/chat_icon.svg" alt="chat" />
    </a>
  );
});

export default Chat;
